const isEmptyObject = (obj) => {
  return !obj || Object.entries(obj)?.length === 0 || obj?.length < 1;
};
export default isEmptyObject;
